// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-Component-Library?node-id=13773%3A18893
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/button.ts

import { ButtonProps } from '@chakra-ui/react';
import { defaultBorder } from 'src/utils';
import { space } from '../space';

const solid = ({ colorScheme: c }: ButtonProps) => ({
  bg: `${c}.500`,
  color: 'white',
  _hover: {
    bg: `${c}.400`,
  },
  _active: {
    bg: `${c}.700`,
  },
});

const ghost = ({ colorScheme: c }: ButtonProps) => ({
  bg: 'transparent',
  color: `${c}.500`,
  _hover: {
    color: `${c}.400`,
  },
  _active: {
    color: `${c}.700`,
  },
});

const outline = ({ colorScheme: c }: ButtonProps) => ({
  ...defaultBorder,
  borderColor: `${c}.500`,
  bg: 'white',
  color: `${c}.500`,
  _hover: {
    borderColor: `${c}.400`,
    color: `${c}.400`,
  },
  _active: {
    borderColor: `${c}.700`,
    color: `${c}.700`,
    bg: `${c}.100`,
  },
});

const link = ({ colorScheme: c }: ButtonProps) => ({
  color: `${c}.500`,
  _active: {
    color: `${c}.700`,
  },
});

const variants = {
  ghost,
  link,
  outline,
  solid,
};

export const Button = {
  baseStyle: {
    borderRadius: 'medium',
  },
  sizes: {
    sm: { w: 40, h: 10 },
    md: { w: space[50], h: 12 },
  },
  variants,
  defaultProps: {
    colorScheme: 'primary',
    size: 'md',
    variant: 'solid',
  },
};
